var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('h2',{staticClass:"step_heading"},[_vm._v(_vm._s(_vm.heading))]),_vm._v(" "),_c('div',{staticClass:"step_description"},[_vm._t("description")],2),_vm._v(" "),_c('div',[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }